import { useTranslation } from '@core/translation';

export const useLandingPageTranslation = () => useTranslation('LANDING_PAGE');

export const useCookiesPageTranslation = () => useTranslation('COOKIES_PAGE');

export const usePrivacyPageTranslation = () => useTranslation('PRIVACY_PAGE');

export const useTermsPageTranslation = () => useTranslation('TERMS_PAGE');
